// extracted by mini-css-extract-plugin
export var deleteModal = "_kq-0";